import { useDialog } from "../hooks/useDialog"
import { getTimeString, parseNum, venueNames } from "../utils/bookings-data"
import Switch from "./Switch"

export const PaymentRow = ({
    payment,
    cashReconciliationId,
    onSwitch = () => {},
    switchValue,
    showSwitch,
    onRectified,
    showRectifyButton,
}) => {

    const dialog = useDialog()
    const oppositeVenueId = payment.venueId === 1 ? 2 : 1

    return (
        <li className="payment-row-container">
            <div className='form-control'>
                <p className='li-data'>
                    <span className='li-field-createdAt'>{getTimeString(payment.createdAt)}</span>
                    <span className='li-field-method'>{payment.method}</span>
                    <span className='li-field-type'>{payment.type}</span>
                </p>
                <p className='li-amount'>
                    <strong><span>{parseNum('EUR',payment.amount)}</span></strong>
                </p>
                {   showSwitch && (
                    <Switch 
                        onInput={e => onSwitch(e)}
                        defaultValue={switchValue}
                    />
                )}
            </div>
            {   showRectifyButton && (
                <>
                <button 
                    type="button"
                    className="btn rmb-btn-secondary"
                    onClick={() => dialog.open('rectify-payment', {cashReconciliationId, payment, onRectified})}
                >
                    Rectificar
                </button>
                { payment.venueId && (

                    <button 
                        type="button"
                        className="btn rmb-btn-secondary"
                        onClick={() => dialog.open('confirm', {
                            message: `¿Está seguro de que quiere cambiar este pago de ${venueNames[payment.venueId]} a ${venueNames[oppositeVenueId]} ?`,
                            callback: () => {
                                onRectified({
                                    id: payment.id,
                                    cashReconciliationId,
                                    method: payment.method,
                                    amount: payment.amount,
                                    type: payment.type,
                                    venueId: oppositeVenueId,
                                })
                            }
                        })}
                    >
                        <span className="material-symbols-rounded">shuffle</span>
                    </button>
                )}
                </>
            )}
        </li>
    )
}